// Interruttore temporaneo: finché è true la card «Comunicati e norme» dell'area riservata
// mostra il badge «In arrivo» e non apre nulla; le pagine /area-riservata/circolari* rimandano
// alla dashboard. L'admin resta operativo. Per aprire l'archivio agli associati: false (serve rebuild).
export const CIRCOLARI_IN_ARRIVO = true;
